module.exports = __webpack_public_path__ + "static/media/bell-53.764b7f42.svg";